import { useContext } from 'react';
import { ScrollContext, ScrollContextResult } from '../ScrollProvider';

function useLayoutScroll(): ScrollContextResult {
  return useContext(ScrollContext);
}

export default useLayoutScroll;
